module.exports = __webpack_public_path__ + "img/projDp.9e3c9295.svg";